import {useSnapshot} from "valtio";
import {useEffect} from "react";
import apiData from "lib/stores/apiData";
import context from "lib/stores/context";
import mapData from "lib/stores/mapData";
import extractKeyValuePairs from "../helpers/extractKeyValuePairs";

let lastHash = "";

export default function useProcessURLHash() {
  const {fetchingTopLevelData} = useSnapshot(apiData);

  useEffect(() => {
    if (fetchingTopLevelData) return;
    processURLHash();
    const listener = () => {
      processURLHash();
    };
    window.addEventListener("hashchange", listener);
    const watcher = setInterval(() => {
      if (lastHash !== window.location.hash) {
        processURLHash();
      }
    }, 200);
    return () => {
      window.removeEventListener("hashchange", listener);
      clearInterval(watcher);
    };
  }, [fetchingTopLevelData]);
}

function processURLHash() {
  lastHash = window.location.hash;
  const url = new URL(window.location.href);
  const params = extractKeyValuePairs(url);

  if (params["mode"] && ["map", "data"].includes(params["mode"])) {
    context.mode = params["mode"];
  } else {
    context.mode = "map";
  }

  if (params["worldwide"]) {
    context.activeTabWorldwide = parseInt(params["worldwide"]);
    context.activeView = "worldwide";
  }

  if (params["region"]) {
    context.activeRegion = parseInt(params["region"]);
    context.activeView = "region";
  }

  if (params["country"]) {
    context.activeCountry = params["country"];
    context.activeRegion = apiData.countries[params["country"]].region_id;
    context.activeView = "country";
  }

  if (params["map"]) {
    mapData.activeCategory = params["map"];
  }

  if (params["product"]) {
    mapData.selectedProduct = params["product"];
  }

  if (params["year"]) {
    mapData.year = "2018";
  }

  if (params["year"] === "2023") {
    mapData.year = "2023";
  }

  if (params["product"] && params["country"]) {
    mapData.selectedProduct = params["product"];
    mapData.showProducts = true;
    mapData.showProductsMobile = true;
    mapData.productsCountry = params["country"];
  }

  if (params["view"] === "worldwide") {
    context.activeView = "worldwide";
  }
  if (params["view"] === "country") {
    context.activeView = "country";
  }
  if (params["view"] === "region") {
    context.activeView = "region";
  }
}
